import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';

type ErrorMessages = {
    minValidError?: string;
    maxValidError?: string;
    maxPocketError?: string;
};

type ValidationResult = {
    errorMessage?: string;
    isError: boolean;
    isShowToViewDetails: boolean;
};

export class ExchangingAmountValidationService {
    private errorMessages: ErrorMessages;

    constructor(errorMessages: ErrorMessages) {
        this.errorMessages = errorMessages;
    }

    getValidationError(
        value: number | string | null | undefined,
        min: number | string | null | undefined,
        max: number | string | null | undefined,
        multiple: number | string | null | undefined,
        isFrom: boolean,
        pocketBalance: number | string | null | undefined,
        currencyCode: string,
        lang: string,
        country: string,
    ): ValidationResult {
        let errorMessage: string | undefined;
        const numericValue = Number(value);
        const numericMin = Number(min);
        const numericMax = Number(max);
        const numericPocketBalance = Number(pocketBalance);

        if (numericValue < numericMin && numericValue) {
            errorMessage = resolveArguments(this.errorMessages.minValidError, [getLocalizedRawAmount(lang, country, min) ?? undefined, currencyCode]);
        } else if (numericMax && numericValue > numericMax) {
            errorMessage = resolveArguments(this.errorMessages.maxValidError, [getLocalizedRawAmount(lang, country, max) ?? undefined, currencyCode]);
        } else if (isFrom && numericPocketBalance && numericValue > numericPocketBalance) {
            errorMessage = resolveArguments(this.errorMessages.maxPocketError, [
                getLocalizedRawAmount(lang, country, pocketBalance) ?? undefined,
                currencyCode,
            ]);
        }

        return {
            errorMessage,
            isError: !!errorMessage,
            isShowToViewDetails: !!errorMessage,
        };
    }
}
